import { render } from "./modal-host.vue?vue&type=template&id=c98602f8"
import script from "./modal-host.vue?vue&type=script&lang=js"
export * from "./modal-host.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__